import {
  Form,
  Select,
  Button,
  DatePicker,
  Segmented,
  Row,
  Col,
  Spin,
} from "antd";
import find from "lodash/find";
import map from "lodash/map";
import get from "lodash/get";
import dayjs from "dayjs";
import isNil from "lodash/isNil";
import {
  getCurrentDateRange,
  customWeekStartEndFormat,
} from "../../utilities/report";
import { getButtonDisabled } from "../../utilities/helpers";
import { fetchCompanyTemplates } from "../../redux/actions/templateActions";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { BREAKDOWN_PERMISSION } from "../../constants";
const HeaderSelector = ({
  filter,
  config,
  form,
  setFilters,
  setConfig,
  getBreakDowns,
}) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
const companies = get(config, "companies", [])
  .filter(company =>
    find(get(company, "feature_permissions", []), ['key', BREAKDOWN_PERMISSION])
  )
  .map(company => ({
    label: get(company, "name"),
    value: get(company, "id"),
  }));
  
  const getCompanyTemplates = (type) => {
    setLoading(true);
    dispatch(fetchCompanyTemplates(get(filter, "company.id"), { type }))
      .then((result) => {
        setConfig({
          ...config,
          templates: result,
        });
        setFilters({
          ...filter,
          templateType: type,
          template: undefined,
          template_name: undefined
        });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  return (
    <Spin spinning={loading}>
      <div className="w-fit px-4 md:px-8 py-6">
        <Row gutter={16}>
          <Col xs={24} md={6}>
            <Form.Item
              name="Company"
              label="Company"
              colon={false}
              layout="vertical"
            >
              <Select
                style={{ minWidth: 250 }}
                size="middle"
                value={get(filter, "company")}
                placeholder="Select Company"
                optionFilterProp="label"
                showSearch
                options={companies}
                onChange={(val) => {
                  const company = find(get(config, "companies"), ["id", val]);
                  setFilters({
                    ...filter,
                    templateType: undefined,
                    template: undefined,
                    template_name: undefined,
                    company,
                  });
                  setConfig({
                    ...config,
                    template_types: get(company, "template_access_list"),
                  });
                  form.setFieldsValue({
                    template: undefined,
                    machine: undefined,
                  });
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={6}>
            <Form.Item
              name="template"
              label="Template"
              colon={false}
              layout="vertical"
            >
              <Select
                style={{ minWidth: 250 }}
                size="middle"
                placeholder="Select Template"
                options={map(get(config, "template_types"), (template) => ({
                  label: get(template, "name"),
                  value: get(template, "value"),
                }))}
                value={get(filter, "templateType")}
                onChange={(value) => {
                  getCompanyTemplates(value);
                  form.setFieldsValue({
                    machine: undefined,
                  })
                }}
                disabled={isNil(get(filter, "company"))}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={6}>
            <Form.Item
              name="machine"
              label="Template"
              colon={false}
              layout="vertical"
            >
              <Select
                style={{ minWidth: 250 }}

                size="middle"
                placeholder="Select Machine"
                options={map(get(config, "templates", []), (template) => ({
                  label: get(template, "name"),
                  value: get(template, "id"),
                }))}
                value={get(filter, "template")}
                onChange={(value) => {
                  const selectedTemplate = find(
                    get(config, "templates", []),
                    (item) => get(item, "id") === value
                  );
                  setFilters({
                    ...filter,
                    template: value,
                    template_name: get(selectedTemplate, "name"),
                  });
                }}
                disabled={isNil(get(filter, "templateType"))}
              />

            </Form.Item>
          </Col>
          <Col xs={24} md={4}>
            <Form.Item name="range" label=" " colon={false} layout="vertical">
              <Segmented
                className="bg-gray-200"
                options={[
                  { label: "Weekly", value: "week" },
                  { label: "Monthly", value: "month" },
                ]}
                value={get(filter, "interval")}
                defaultValue={"week"}
                onChange={(interval) => {
                  setFilters({
                    ...filter,
                    interval,
                    date: getCurrentDateRange(interval, dayjs()),
                  });
                }}
                disabled={isNil(get(filter, "template_name"))}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={6}>
            <div className="mt-8 ">
              {get(filter, "interval") === "week" ? (
                <DatePicker
                  onChange={(value) => {
                    setFilters({
                      ...filter,
                      date: getCurrentDateRange(get(filter, "interval"), value),
                    });
                  }}
                  style={{ minWidth: 250 }}
                  format={customWeekStartEndFormat}
                  showWeek={false}
                  value={dayjs(get(filter, "date.0"), "YYYY-MM-DD")}
                  picker="week"
                  disabled={isNil(get(filter, "template_name"))}
                />
              ) : (
                <DatePicker
                  style={{ minWidth: 250 }}
                  format={"MM-YYYY"}
                  onChange={(value) => {
                    setFilters({
                      ...filter,
                      date: getCurrentDateRange(get(filter, "interval"), value),
                    });
                  }}
                  value={dayjs(get(filter, "date.0"), "YYYY-MM-DD")}
                  picker="month"
                  disabled={isNil(get(filter, "template_name"))}
                />
              )}
            </div>
          </Col>
          <Col xs={24} md={2}>
            <Form.Item name="submit" label=" " colon={false} layout="vertical">
              <Button
                type="primary"
                className="w-30"
                onClick={() => getBreakDowns()}
                disabled={getButtonDisabled(filter, [
                  "templateType",
                  "company",
                  'template',
                  "date",
                ])}
              >
                Submit
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </div>
    </Spin>
  );
};
export default HeaderSelector;